import { Directive, ElementRef, OnInit } from '@angular/core';

@Directive({
    selector: '[slider]'
})
export class SliderDirective implements OnInit {
    constructor(private el: ElementRef) { }
    getUnique(): string[] {
        const uniqueClasses: string[] = [];
        const validClasses: string[] = [
            "col-md-1", "col-md-2", "col-md-3", "col-md-4", "col-md-6", "col-md-12",
            "col-sm-1", "col-sm-2", "col-sm-3", "col-sm-4", "col-sm-6", "col-sm-12",
            "col-lg-1", "col-lg-2", "col-lg-3", "col-lg-4", "col-lg-6", "col-lg-12",
            "col-xs-1", "col-xs-2", "col-xs-3", "col-xs-4", "col-xs-6", "col-xs-12",
            "col-xl-1", "col-xl-2", "col-xl-3", "col-xl-4", "col-xl-6", "col-xl-12"
        ];

        const itemDivs: NodeListOf<HTMLDivElement> = this.el.nativeElement.querySelectorAll('.carousel-item');
        itemDivs.forEach((div: HTMLDivElement) => {
            const classList: string[] = div.className.split(/\s+/);
            classList.forEach(className => {
                if (validClasses.includes(className) && !uniqueClasses.includes(className)) {
                    uniqueClasses.push(className);
                }
            });
        });

        return uniqueClasses;
    }
    setcss(e: string[], l: string, s: string) {
        const breakpoints: number[] = [1200, 992, 768, 567, 0];
        let t: string[] = ["", "", "", "", "", ""];
        let c = 0, d = 0, f = 0, g = 0;
        let o: string[] = [];

        for (let a = 0; a < e.length; a++) {
            const i = e[a].split("-");
            if (i.length === 3) {
                switch (i[1]) {
                    case "xl":
                        d = 0;
                        break;
                    case "lg":
                        d = 1;
                        break;
                    case "md":
                        d = 2;
                        break;
                    case "sm":
                        d = 3;
                        break;
                    case "xs":
                        d = 4;
                        break;
                }
                t[d] = i[2];
            }
        }

        for (let n = 0; n < t.length; n++) {
            if (t[n] !== "") {
                if (c === 0) {
                    c = 12 / parseInt(t[n]);
                }
                f = 12 / parseInt(t[n]);
                g = 100 / f;
                let a = `${s} > .carousel-item.active.carousel-item-right, ${s} > .carousel-item.carousel-item-next {-webkit-transform: translate3d(${g}%, 0, 0);transform: translate3d(${g}%, 0, 0);left: 0;} ${s} > .carousel-item.active.carousel-item-left, ${s} > .carousel-item.carousel-item-prev {-webkit-transform: translate3d(-${g}%, 0, 0);transform: translate3d(-${g}%, 0, 0);left: 0;} ${s} > .carousel-item.carousel-item-left, ${s} > .carousel-item.carousel-item-prev.carousel-item-right, ${s} > .carousel-item.active {-webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);left: 0;}`;

                if (f > 1) {
                    for (let k = 0; k < f - 1; k++) {
                        o.push(`${l} .cloneditem-${k}`);
                    }
                    if (o.length) {
                        a += `${o.join(",")} {display: block;}`;
                    }
                    o = [];
                }
                if (breakpoints[n] !== 0) {
                    a = `@media all and (min-width: ${breakpoints[n]}px) { ${a} }`;
                    const styleElement = document.createElement('style');
                    styleElement.textContent = a;
                    document.head.prepend(styleElement);
                }
            }
        }
        console.log(document.querySelectorAll(l).length)
        const elements = Array.from(document.querySelectorAll(l));
        elements.forEach(element => {
            let e: Element | null | undefined = element;
            for (let i = 0; i < c - 1; i++) {
            //   e = e?.nextElementSibling ?? element.parentElement?.firstElementChild;
              if (e) {
                const clonedItem = element.firstElementChild?.cloneNode(true) as HTMLElement;
                clonedItem.classList.add(`cloneditem-${i}`);
                element.appendChild(clonedItem);
              }
            }
          });
    }
    ngOnInit(): void {
        var item = '.carousel-item';
        var item_inner = ".carousel-inner";
        let classes = this.getUnique();
        this.setcss(classes, item, item_inner);
    }
}
